import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { Constants } from 'src/app/shared/model/Constants';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'app-numeric-plus-minus-input-ctrl',
  templateUrl: './numeric-plus-minus-input.component.html',
  styleUrls: ['./numeric-plus-minus-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: NumericPlusMinusInputComponent,
    multi: true
  }]
})
export class NumericPlusMinusInputComponent implements ControlValueAccessor {

  constructor(private controlContainer: ControlContainer) {
  }

   @ViewChild(FormControlDirective, {static: true})
   
   formControlDirective: FormControlDirective;
   
   @Input() formControlName: string;
   @Input() caption: string;
   @Input() boldCaption = false;

   @Input() settings:ControlSettings = {};
   defaultSettings:ControlSettings = {format:'n',step:1, fxFill:false, min:0,max:Constants.MaxInt};

  
   @Output() valueChangeEvent = new EventEmitter<number>();

   ngOnInit(): void {
   Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

  }

  ngAfterViewInit() {
    const selector = '#' + this.formControlName + ' .k-input';
    const input = document.querySelector(selector) as HTMLElement;
    if(input){
      input.setAttribute("inputmode", "numeric");
    }
  }

  addToValue(n:number){
    let currentValue = this.control.value;
    if(!Number.isInteger(currentValue)){
      currentValue = 0;
    }

    if((currentValue + n) <=  this.settings.max && (currentValue + n) >= this.settings.min){
      this.control.setValue(currentValue + n);
      this.valueChangeEvent.emit(this.control.value);
    }
    
    
  }

  get control() {
    return  this.controlContainer.control.get(this.formControlName);
  }

  onChange(value:string){
    this.control.setValue(value);
    this.valueChangeEvent.emit(this.control.value);
  }

  
  //implement ControlValueAccessor
  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }


}
